<template>
  <div class="d-flex align-items-center py-2 px-3">
    <a
      v-if="reiseterminId && aktuellerReisetermin && !isFitPage"
      :href="'#/reisetermine/' + reiseterminId + '?vorgangdetailstab=vorgaenge&scrollToFlugdaten=true'"
      target="_blank"
      style="text-decoration: none; color: inherit; padding: 0 5px"
      class="d-flex justify-content-center mr-4"
    >
      <div
        style="min-width: 180px"
        class="d-flex align-items-center justify-content-center status-bar-button"
        v-b-tooltip.hover.bottom
        :title="'Reisetermindetailseite'"
      >
        <span class="d-flex align-items-center">
          <Earth class="mr-2" :size="20" />
          <b>{{ aktuellerReisetermin }}</b>
        </span>
      </div>
    </a>

    <div
      v-if="aktuellerReisetermin && isFitPage"
      style="min-width: 180px; padding: 0 5px"
      class="d-flex align-items-center justify-content-center status-bar-info mr-4"
    >
      <span class="d-flex align-items-center">
        <Earth class="mr-2" :size="20" />
        <b>{{ aktuellerReisetermin }}</b>
      </span>
    </div>

    <div
      v-if="durchfuehrungUnterMtz"
      class="status-bar-button d-flex justify-content-center mr-4"
      style="width: 36px"
      v-b-tooltip.hover.bottom
      :title="'Durchführung unter MTZ bestätigt'"
    >
      <span class="d-flex align-items-center"><UserCheck :size="20" /></span>
    </div>

    <div style="width: 100px" class="d-flex justify-content-center mr-4 status-bar-info">
      <span class="d-flex align-items-center">
        <Users class="mr-2" :size="20" />
        <b class="mr-1">PAX:</b>
        {{ anzahlPax }}
      </span>
    </div>

    <div
      :style="{ minWidth: '150px' }"
      class="d-flex justify-content-center mr-4 status-bar-info px-3"
      v-b-tooltip.hover.html.bottom
      :title="gesamtBetragTooltip"
    >
      <span class="d-flex align-items-center">
        <Coins class="mr-2" :size="20" />
        <b class="mr-1">Gesamtbetrag:</b>
        <b v-if="gesamtBetrag === null">-</b>
        <span v-else>{{ formatBetrag(gesamtBetrag) }} {{ waehrung }}</span>
        <span v-if="betragSummeMarkierterLeistungen !== null && waehrungMarkierterLeistungen" class="ml-1">
          (Markierte Leistungen: {{ formatBetrag(betragSummeMarkierterLeistungen) }}
          {{ waehrungMarkierterLeistungen }})
        </span>
      </span>
    </div>

    <div style="min-width: 150px" class="d-flex justify-content-center mr-4 status-bar-info px-3">
      <span class="d-flex align-items-center">
        <HandCoins class="mr-2" :size="20" />
        <b class="mr-1">Offener Betrag:</b>
        <b v-if="offenerBetrag === null">-</b>
        <span v-else>{{ formatBetrag(offenerBetrag) }} {{ waehrung }}</span>
      </span>
    </div>
  </div>
</template>

<script>
import { Earth, UserCheck, Users, Coins, HandCoins } from 'lucide-vue';

export default {
  components: {
    Earth,
    UserCheck,
    Users,
    Coins,
    HandCoins,
  },
  data() {
    return {
      reiseterminId: null,
      aktuellerReisetermin: null,
      durchfuehrungUnterMtz: false,
      isFitPage: false,
      anzahlPax: 0,
      gesamtBetrag: null,
      offenerBetrag: null,
      waehrung: '',
      gesamtBetragTooltip: '',
      betragSummeMarkierterLeistungen: null,
      waehrungMarkierterLeistungen: '',
    };
  },
  methods: {
    setReiseterminData(data) {
      this.reiseterminId = data.id;
      this.aktuellerReisetermin = data.aktuellerReisetermin;
      this.durchfuehrungUnterMtz = data.durchfuehrungUnterMtzDurchSkr;
      this.isFitPage = data.isFitPage || false;
    },
    setAnzahlPax(anzahlPax) {
      this.anzahlPax = anzahlPax;
    },
    setGesamtBetrag(gesamtBetrag) {
      this.gesamtBetrag = gesamtBetrag;
    },
    setOffenerBetrag(offenerBetrag) {
      this.offenerBetrag = offenerBetrag;
    },
    setWaehrung(waehrung) {
      this.waehrung = waehrung;
    },
    setGesamtBetragTooltip(tooltip) {
      this.gesamtBetragTooltip = tooltip;
    },
    setBetragSummeMarkierterLeistungen(summe, waehrung) {
      this.betragSummeMarkierterLeistungen = summe;
      this.waehrungMarkierterLeistungen = waehrung || '';
    },
    formatBetrag(betrag) {
      if (betrag == null) return null;
      return betrag.toLocaleString('de-DE', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
    },
  },
};
</script>

<style scoped>
.status-bar-button,
.status-bar-info {
  border: 1px solid var(--border);
  background-color: var(--surface);
  height: var(--control-h);
  border-radius: var(--radius-sm);
}
.status-bar-button:hover {
  background-color: var(--surface-hover) !important;
  border-color: var(--border-strong) !important;
  cursor: pointer;
}
</style>
